import React from 'react';

import { withScoutTheme } from '@/components/ThemeContext/ThemeContext';

interface Props {
  companyName: string;
}

const UnsubscribeCompletion = ({ companyName }: Props) => (
  <div className="container">
    <div className="center">
      <h4>You have successfully unsubscribed from {companyName}</h4>
      <p>Sorry to see you go!</p>
    </div>
  </div>
);

export default withScoutTheme(UnsubscribeCompletion);
